import React from "react";
import { useNavigate } from "react-router-dom";
import PlayerSearchView from "./PlayerSearchView";
import { useSportWorkspace } from "../../hooks/useSportWorkspace";
import { usePlayerSearchPage } from "../../hooks/usePlayerSearchPage";
import { getPlayerPath } from "../../utils/fanPage";
import {
  getTeamDetailPath,
  pathForDirectoryOption,
} from "./playerSearchCatalog";

const PlayerSearchPage = () => {
  const navigate = useNavigate();
  const { sport } = useSportWorkspace();
  const {
    catalog,
    searchQuery,
    handleSearchInputChange,
    featuredTiles,
    featuredLoading,
    featuredError,
    railTeams,
    railLoading,
    railError,
  } = usePlayerSearchPage(sport);

  return (
    <PlayerSearchView
      catalog={catalog}
      searchQuery={searchQuery}
      onSearchInputChange={handleSearchInputChange}
      onSelectOption={(option) => {
        const path = pathForDirectoryOption(option, sport);
        if (path) navigate(path);
      }}
      featuredTiles={featuredTiles}
      featuredLoading={featuredLoading}
      featuredError={featuredError}
      railTeams={railTeams}
      railLoading={railLoading}
      railError={railError}
      onFeaturedSelect={(playerId) => {
        const path = getPlayerPath(playerId, sport);
        if (path) navigate(path);
      }}
      onTeamSelect={(teamName) => {
        const path = getTeamDetailPath(sport, teamName);
        if (path) navigate(path);
      }}
      onShortcut={(path) => {
        if (path) navigate(path);
      }}
    />
  );
};

export default PlayerSearchPage;
